var THREE         = require("three"); 
var PositionHandleView  = require("./../abstract/positionHandleView.js");
var lib_core      = require("lib-core");

var VertHandleView = function (model, editorView, handleId, config) {
    PositionHandleView.call(this, model, editorView, handleId, config);
}
lib_core.inherit(VertHandleView, PositionHandleView);

VertHandleView.prototype.repositionMesh = function(mesh, position, rotation){
    var matrix = (new THREE.Matrix4())
    matrix.setPosition( position.toThreejs() );
    mesh.matrix = matrix;
}

VertHandleView.prototype.buildMesh = function(){
    var obj = new THREE.Object3D();
    obj.matrixAutoUpdate = false;

    var geom = this.buildGeometry(3)//.rotateX(Math.PI/2);
    var mesh = new THREE.Mesh(geom, this.material);
    
    obj.add(mesh);
    return obj;
}


VertHandleView.prototype.hoverChanged = function(value){
    if(value){
        this.material.transparent = false;
    } else {
        this.material.transparent = true;
    }
} 

 
module.exports = VertHandleView;